<template lang="pug">
.input-container.input-image
  input.input(v-if="index >= 0" v-model="dataForm[property][index]" autocomplete="ño" :required="required >= 0 ? index + 1 <= required : false" @blur="getImageSrc()" @keydown.enter.prevent="getImageSrc()" @input="$emit('input')")
  input.input(v-else v-model="dataForm[property]" autocomplete="ño" @blur="getImageSrc()" @keydown.enter.prevent="getImageSrc()" :required="required === 1")
  label.label(:class="{ show: index >= 0 ? dataForm[property][index] : dataForm[property] }")
    shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" :property="property" :title="title" :index="index")
  .delete-button.times-icon.mini-button(@click="$emit('discard')" v-show="index >= 0 && index + 1 > required")

  .preview-text-input-image Vista Previa
  .image-container-input(:class="classContainerImage")
    img.image-input(:class="classImage" :src="src" alt="no-image" @error="emitState('error')" @load="emitState('load')")
</template>

<script>
import shProperty from '@/components/elements/Property'

export default {
  name: 'InputImage',

  components: { shProperty },

  data () {
    return {
      src: '',
      error: ''
    }
  },

  props: {
    folder: String,
    subfolder: String,
    dataForm: Object,
    property: String,
    type: String,
    pattern: String,
    title: String,
    dataOriginal: Object,
    required: Number,
    classImage: String,
    classContainerImage: String,
    noImagePath: String,
    index: Number,
    disabled: Boolean,
    imagePath: String,
    brand: String
  },

  mounted () {
    this.getImageSrc()
  },

  methods: {
    getImageSrc () {
      const value = this.index >= 0 ? this.dataForm[this.property][this.index] : this.dataForm[this.property]

      if (!this.folder || !value) {
        this.src = this.noImagePath
      } else {
        if (this.subfolder) {
          this.src = `${this.imagePath}/${this.brand ? `${this.brand}/` : ''}${this.folder}/${this.subfolder}/${value}`
        } else {
          this.src = `${this.imagePath}/${this.folder}/${value}`
        }
      }
    },
    emitState (state) {
      if (state === 'error') {
        this.src = this.noImagePath
        if (this.index >= 0) {
          this.dataForm[this.property][this.index] = ''
        } else {
          this.dataForm[this.property] = ''
        }
      }
      this.$emit(state)
    }
  },

  watch: {
    folder (value) {
      this.getImageSrc()
    }
  }
}
</script>

<style lang="stylus">
.input-image
  width 100%
  text-align center
  display block

.image-input
  max-height 150px

.preview-text-input-image
  margin 1em 0 .5em 0
</style>



// WEBPACK FOOTER //
// src/components/elements/InputImage.vue